module.exports = __webpack_public_path__ + "static/media/ankievanwersch.9a560f87.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/ankievanwersch.webp
// module id = 355
// module chunks = 0